<div *ngIf="!isBotMode()" class="container-fluid">
    <div class="row">
        <!-- sidemenu block start  -->
        <div class="col-12 col-lg-2 col-md-12">

            <app-sidebar #sidebar></app-sidebar>

        </div>
        <!-- sidemenu block end  -->

        <!-- content block start  -->
        <div class="col-md-10 mx-auto col-12 content-block">
            <div class="content-wrap">
                <button (click)="sidebar.toggleSidebar($event)" class="btn mobile-toggler md-none btn-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                        fill="currentColor">
                        <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2" />
                        <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2" />
                        <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2" />
                    </svg>
                </button>
                <div class="content-block">
                    <app-work-play-toggle-tab></app-work-play-toggle-tab>
                    <div class="row">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
            <app-disclaimer-msg></app-disclaimer-msg>
        </div>
        <!-- content block end  -->
    </div>
</div>
<div *ngIf="isBotMode()">
    <router-outlet></router-outlet>

</div>